<template>
  <div class="header-wrapper">
    <header>
      <v-layout wrap class="justify-space-between align-center">
        <v-flex>
          <v-btn
            class="sidebar-toggle-btn ma-0"
            icon
            solo
            color
            :ripple="false"
            small
            @click="toggleSidebar">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="stroke-current">
              <circle cx="12" cy="12" r="10"></circle>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
          </v-btn>
          <router-link to="/dashboard" class="header-logo-link">
            <span class="brand-logo">
              <img v-if="!isDark" class="logo" src="../../assets/img/logos/logo-black.png" alt="">
              <img v-if="isDark" class="logo" src="../../assets/img/logos/logo-white.png" alt="">
            </span>
          </router-link>
        </v-flex>
        <v-flex>
          <v-layout align-center justify-end>
            <icons-bar :params="getAccountParams" />
            <User :userIsLogged="userIsLogged" :params="getAccountParams" />
          </v-layout>
        </v-flex>
      </v-layout>
    </header>
  </div>
</template>

<script>
import User from './User'
import IconsBar from './IconsBar'
export default {
  name: 'Header',
  components: {
    User,
    IconsBar
  },
  computed: {
    sidebarIsOpen () {
      return this.$store.state.sidebar.sidebarOpen
    },
    userIsLogged () {
      return this.$store.state.auth.authtoken
    },
    getAccountParams () {
      return this.$store.state.auth.accountParams
    },
    isDark () {
      if (this.$store.state.auth.userInfo.themeColor === '0') return true
    }
  },
  methods: {
    toggleSidebar () {
      this.$store.dispatch('sidebar/toggleSidebar')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue